import React, { useEffect, useState } from "react";
import "./Subordinate_Data.css";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";
import Filter_Drop from "../Common/Common_Component/Filter_Drop/Filter_Drop";
import Subordinate_Data_card from "./Subordinate_Data_card/Subordinate_Data_card";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMagnifyingGlass,
  faRotateRight,
} from "@fortawesome/free-solid-svg-icons";
import { Form, InputGroup } from "react-bootstrap";
import No_data from "../Common/No_data/No_data";
import { useDispatch, useSelector } from "react-redux";
import { CommissionHistry } from "../../features/auth/Slice";
import CustomPagination from "../Common/Common_Component/CustomPagination/CustomPagination";

function Subordinate_Data() {
  const [showDate, setShowDate] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedApp, setSelectedApp] = useState(null);

  const [search, setSearch] = useState("");
  const options = [
    { label: "All", id: null },
    { label: "Pending", id: 1 }, // Processing
    { label: "Completed", id: 2 }, // Accepted
    { label: "Rejected", id: 3 },
  ];

  const dispatch = useDispatch();

  const commission_history = useSelector(
    (state) => state.auth.commission_history,
  );

  console.log({ commission_history });

  const fetch = async (page = 1) => {
    await dispatch(
      CommissionHistry({ page: page, start_date: selectedDate, name: search }),
    );
  };

  const handlePageChange = async (page) => {
    fetch(page);
  };

  useEffect(() => {
    fetch();
  }, [dispatch, selectedDate]);

  return (
    <>
      <section className="Subordinate_Data">
        <Common_white_header headingText={"Subordinate Data"} />
        <div className="container">
          {/* <div className="search_feild_holder  ">
            <InputGroup className="mb-3">
              <Form.Control
                placeholder="Search Subordinate UID"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />

              <InputGroup.Text
                id="basic-addon2"
                style={{ cursor: "pointer" }}
                onClick={() => fetch(1)}
              >
                <FontAwesomeIcon icon={faMagnifyingGlass} />
              </InputGroup.Text>
            </InputGroup>
          </div> */}
          <div className="reset-wrapper">
            <div className="w-100">
              <Filter_Drop
                options={options}
                showDate={showDate}
                setShowDate={setShowDate}
                showFilter={showFilter}
                setShowFilter={setShowFilter}
                selectedDate={selectedDate}
                setSelectedDate={setSelectedDate}
                selectedApp={selectedApp}
                setSelectedApp={setSelectedApp}
              />
            </div>
            <button
              className="reset-btnn"
              onClick={() => {
                setSelectedDate("");
              }}
            >
              <FontAwesomeIcon icon={faRotateRight} /> Reset
            </button>
          </div>
          {/* <div className="Rebate_Ratio_holder">
            <div className="row me-0 ms-0">
              <div className="col-6 border_col">
                <div className="text_holder">
                  <h3>0.19</h3>
                  <p>Deposit Number</p>
                </div>
              </div>

              <div className="col-6">
                <div className="text_holder">
                  <h3>657.52</h3>
                  <p>Deposit Amount</p>
                </div>
              </div>

              <div className="col-6 border_col">
                <div className="text_holder">
                  <h3>0.19</h3>
                  <p>Number of bettors</p>
                </div>
              </div>

              <div className="col-6">
                <div className="text_holder">
                  <h3>657.52</h3>
                  <p>Total bet</p>
                </div>
              </div>

              <div className="col-6 border_col">
                <div className="text_holder">
                  <h3>15</h3>
                  <p>Number of People making first deposit</p>
                </div>
              </div>

              <div className="col-6">
                <div className="text_holder">
                  <h3>0</h3>
                  <p>First Deposit amount</p>
                </div>
              </div>
            </div>
          </div> */}
          {commission_history?.data?.length > 0 ? (
            <Subordinate_Data_card data={commission_history?.data} />
          ) : (
            <>
              <No_data />

              {/* <button
                className="btn_details"
                onClick={() => {
                  setSelectedDate("");
                }}
              >
                Reset details
              </button> */}
            </>
          )}

          {commission_history?.total_pages > 1 && (
            <CustomPagination
              currentPage={commission_history?.current_page}
              totalPages={commission_history?.total_pages}
              handlePageChange={handlePageChange}
            />
          )}
        </div>
      </section>
    </>
  );
}

export default Subordinate_Data;
